(ns minorodata.components.data-views.preview
  (:require [minorodata.app.handlers :refer [dispatch dispatch-sync]]
            [ui.data-grid.preview :as data-grid-preview]
            [minorodata.data-views.model :refer [->data-views-page]]
            [re-posh.core :as re-posh]
            [react :as react]
            [ui.tabs :refer [tabs]]
            ["react-resize-detector" :refer [useResizeDetector]]))

(defn table [{:keys [current-tab has-tabs?]}]
  (let [preview-height    @(re-posh/subscribe [:data-views-page/prop :data-views-page/data-preview-height])
        height            (if (some? preview-height)
                            (-> (js/Math.ceil preview-height)
                                (- (if has-tabs? 48 0)))
                            "100%")

        [sorted-titles sorted-data]
        (react/useMemo
         (fn []
           (let [{:keys [indexed-headers indexed-data]} current-tab
                 fields-getter (mapv (fn [{:keys [field]}] #(get % field)) indexed-headers)]
             [(mapv :title indexed-headers)
              (mapv (apply juxt fields-getter) indexed-data)]))
         #js [current-tab])
        dark-mode? @(re-posh/subscribe [:app/prop :app/dark-mode?])]

    [:f> data-grid-preview/table
     {:headers                   sorted-titles
      :rows                      sorted-data
      :dark-mode?                dark-mode?
      :height                    height
      :column-width              150
      :sortable?                 true
      :filterable?               true
      :resizable?                true
      :row-numbers?              true
      :suppress-no-rows-overlay? true}]))

(defn ->tab [statement-idx]
  {:label (str "Statement #" (inc statement-idx))
   :value statement-idx})

(defn pick-tab [id]
  (dispatch-sync [:data-views-page/update
                  (->data-views-page {:results-tab id})]))

(defn preview []
  (let [preview-data @(re-posh/subscribe [:data-views.subs/preview-data])
        tab          (or @(re-posh/subscribe [:data-views-page/prop :data-views-page/results-tab]) 0)
        current-tab  (nth preview-data tab nil)
        has-tabs?    (> (count preview-data) 1)

        {:keys [ref]} (js->clj (useResizeDetector #js {:handleWidth  true
                                                       :handleHeight true
                                                       :refreshMode  "throttle"
                                                       :refreshRate  100
                                                       :onResize     (fn [params]
                                                                       (let [{:keys [height]} (js->clj params :keywordize-keys true)]
                                                                         (dispatch [:data-views-page/update (->data-views-page {:data-preview-height height})])))})
                               :keywordize-keys true)]
    [:div {:class "h-full overflow-hidden z-0"
           :ref ref}

     (when has-tabs?
       [tabs {:variant         :underlined
              :default-value   tab
              :value           tab
              :tabs            (mapv ->tab (range (count preview-data)))
              :on-value-change pick-tab}])
     [:f> table {:current-tab current-tab
                 :has-tabs?   has-tabs?}]]))
